export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/HU-0400af7f2e740d65681c36b505a59671.png";